import type { TranslationKey } from './en.js';

export const zh: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': '聊天',
  'section.image': '图像',
  'section.video': '视频',
  'section.video2': '视频 2 (Marketing Studio)',
  'section.character': '角色',
  'section.audio': '音乐与音频',
  'section.voice': '语音',
  'section.design': '设计',

  'common.loading': '加载中…',
  'common.error': '出错了',
  'common.retry': '重试',
  'common.refresh': '刷新',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.save': '保存',
  'common.close': '关闭',
  'common.delete': '删除',
  'common.create': '创建',
  'common.apply': '应用',
  'common.offline': '离线 — 显示缓存数据',
  'common.you': '你',
  'common.assistant': '助手',
  'common.empty': '这里还没有内容',
  'common.back': '返回',

  'auth.loading': '正在登录…',
  'auth.openInTelegram': '请在 Telegram 中打开',
  'auth.openInTelegramHint': 'Volt 是 Telegram 小程序。请从与机器人的对话中启动它以登录。',
  'auth.retry': '重试',
  'auth.error': '无法登录',
  'auth.devHint': '开发者预览 — 无 Telegram 数据。',

  'topbar.menu': '打开菜单',
  'topbar.settings': '设置',
  'topbar.balance': '余额',

  'directChat.open': '打开私人聊天',
  'pager.chat': '聊天',
  'pager.label': '页面切换',
  'directChat.title': '私人聊天',
  'directChat.yourId': '你的 ID：{id}',
  'directChat.addPlaceholder': '公开 ID 或 Telegram @用户名',
  'directChat.addFriend': '添加好友',
  'directChat.addSelf': '不能将自己添加为好友。',
  'directChat.friends': '好友',
  'directChat.noFriends': '还没有好友。请通过公开 ID 或 Telegram @用户名添加。',
  'directChat.selectFriend': '选择好友以打开对话。',
  'directChat.noMessages': '还没有消息，打个招呼吧！',
  'directChat.messagePlaceholder': '输入消息…',
  'directChat.send': '发送消息',
  'directChat.notFound': '找不到具有该 ID 或 Telegram 用户名的用户。',
  'directChat.noPermission': '只能给好友发送消息。',
  'directChat.addError': '请检查 ID 或用户名；此用户可能已添加。',
  'directChat.error': '无法加载聊天，请重试。',
  'directChat.openDrawer': '打开会话列表',
  'directChat.chats': '会话',
  'directChat.groups': '群组',
  'directChat.newGroup': '新建群组',
  'directChat.createGroup': '创建群组',
  'directChat.groupName': '群组名称',
  'directChat.selectMembers': '选择成员（包括你在内 {count}/50）',
  'directChat.memberCount': '{count} 位成员',
  'directChat.messages': '消息',
  'directChat.messageActions': '消息操作',
  'directChat.reply': '回复',
  'directChat.replyingTo': '回复 {name}',
  'directChat.forward': '转发',
  'directChat.forwarded': '已转发',
  'directChat.chooseDestination': '选择转发的会话',
  'directChat.deleteForMe': '仅为我删除',
  'directChat.deleteForEveryone': '为所有人删除',
  'directChat.deleteForEveryoneConfirm': '为聊天中的所有人删除此消息吗？',
  'directChat.aiAttribution': '人工智能',
  'directChat.aiToggleEnabled': '已启用 AI 回复',
  'directChat.aiToggleDisabled': '已禁用 AI 回复',
  'directChat.aiGenerating': 'AI 正在回复…',
  'directChat.aiGenerationError': '生成 AI 回复失败：{error}',
  'directChat.aiChooseModel': '选择 AI 模型',
  'directChat.aiLongPressHint': '长按选择模型',
  'directChat.sent': '已发送',
  'directChat.delivered': '已送达',
  'directChat.read': '已读',

  'sidebar.title': '聊天',
  'sidebar.newChat': '新聊天',
  'sidebar.search': '搜索',
  'sidebar.searchPlaceholder': '搜索聊天…',
  'sidebar.projects': '项目',
  'sidebar.newProject': '新项目',
  'sidebar.noConversations': '还没有对话',
  'sidebar.archived': '已归档',
  'sidebar.showArchived': '显示归档',
  'sidebar.hideArchived': '隐藏归档',
  'sidebar.pinned': '已置顶',
  'sidebar.today': '今天',
  'sidebar.yesterday': '昨天',
  'sidebar.previous7Days': '过去 7 天',
  'sidebar.previous30Days': '过去 30 天',
  'sidebar.older': '更早',

  'menu.rename': '重命名',
  'menu.pin': '置顶',
  'menu.unpin': '取消置顶',
  'menu.archive': '归档',
  'menu.unarchive': '取消归档',
  'menu.addToFolder': '添加到文件夹',
  'menu.moveUp': '上移',
  'menu.moveDown': '下移',
  'menu.delete': '删除',
  'menu.deleteTitle': '删除聊天？',
  'menu.deleteConfirm': '此对话及其消息将被永久删除。',

  'project.name': '项目名称',
  'project.description': '描述',
  'project.systemPrompt': '自定义指令',
  'project.systemPromptHint': '这些指令会在项目的每个聊天中发送给模型。',
  'project.create': '创建项目',
  'project.empty': '还没有项目',

  'composer.placeholder': '发消息给 Volt…',
  'composer.imagePlaceholder': '描述你想要的图像…',
  'composer.videoPlaceholder': '描述你想要的视频…',
  'composer.characterPlaceholder': '描述角色…',
  'composer.audioPlaceholder': '描述你想要的音乐或音频…',
  'composer.voicePlaceholder': '要转成语音的文字…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': '角色',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'AI 影响者',
  'character.soulIdTitle': '训练 Soul ID',
  'character.characterTitle': '角色',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'AI 影响者',
  'character.name': '名称',
  'character.description': '描述',
  'character.bio': '简介',
  'character.style': '风格',
  'character.scene': '场景',
  'character.prompt': '提示词',
  'character.referenceImages': '参考图片 URL，每行一个',
  'character.pickSoulId': '选择 Soul ID',
  'character.pickCharacter': '选择角色',
  'character.noSoulLinked': '未关联 Soul ID',
  'character.scopeLabel': '创建内容',
  'character.scopeHead': '头部',
  'character.scopeFullBody': '全身',
  'character.scopeHeadHint': '从不同角度拍摄的面部特写效果最佳。',
  'character.scopeFullBodyHint': '请添加全身照片，以便生成完整的身体。',
  'character.scopeBadgeHead': '头部',
  'character.scopeBadgeFullBody': '全身',
  'character.model3dCreate': '创建 3D 模型',
  'character.model3dView': '查看 3D',
  'character.model3dBuilding': '正在生成 3D 模型…需要几分钟。',
  'character.model3dFailed': '无法生成 3D 模型',
  'character.model3dRetry': '重试',
  'character.model3dStarted': '正在生成 3D 模型',
  'character.model3dStage': '3D 模型查看器',
  'character.model3dLoading': '正在加载模型…',
  'character.model3dError': '无法打开 3D 模型。',
  'character.model3dUnsupported': '您的设备不支持 3D（WebGL）。',
  'character.model3dHint': '拖动旋转 · 双指捏合或滚轮缩放',
  'character.model3dReset': '重置视角',
  'character.model3dAutoRotate': '自动旋转',
  'character.soulIdPhotoHint': '上传 5–20 张参考照片。',
  'character.soulIdPhotoCount': '请选择 5 到 20 张照片。',
  'character.soulIdUploadFailed': '照片上传失败，请重试。',
  'character.createSoulId': '创建 Soul ID',
  'character.createCharacter': '创建角色',
  'character.createAiInfluencer': '创建 AI 影响者',
  'character.generateSoulCast': '生成 Soul Cast',
  'character.generateContent': '生成内容',
  'character.status.training': '训练中',
  'character.status.ready': '就绪',
  'character.status.failed': '失败',
  'composer.send': '发送',
  'composer.stop': '停止',
  'composer.attach': '附加文件',
  'composer.attachTitle': '添加附件',
  'composer.attachAllPhotos': '所有照片',
  'composer.attachCamera': '相机',
  'composer.attachPhotos': '照片',
  'composer.attachFiles': '文件',
  'composer.attachFilesHint': '照片不压缩',
  'composer.attachToFolder': '添加到文件夹',
  'composer.voiceInput': '语音输入',
  'composer.listening': '正在聆听…',
  'composer.thinking': '思考中…',
  'composer.model': '模型',
  'composer.selectModel': '选择模型',
  'composer.unavailable': '不可用',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': '请将余额充值到 {amount} 以继续',
  'composer.generate': '生成',

  'message.copy': '复制',
  'message.copied': '已复制',
  'message.share': '分享',
  'message.regenerate': '重新生成',
  'message.edit': '编辑',
  'message.save': '保存并重新发送',
  'message.up': '回答不错',
  'message.down': '回答不好',
  'message.usage': '{model} · 输入 {input} · 输出 {output} · {cost}',
  'message.usageNoModel': '输入 {input} · 输出 {output} · {cost}',
  'message.failed': '生成失败',
  'message.reasoningTitle': '处理过程',
  'conversation.pinnedBadge': '已置顶对话',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': '发送到聊天',
  'share.noDestinations': '没有可用的聊天或群组',
  'share.sentSuccess': '已发送！',
  'share.sending': '发送中…',
  'share.loadingDestinations': '正在加载聊天…',
  'artifact.preview': '预览',
  'artifact.code': '代码',
  'artifact.open': '打开工件',
  'artifact.export': '导出',
  'artifact.download': '下载',
  'artifact.copy': '复制',
  'artifact.edit': '编辑',
  'artifact.close': '关闭',
  'artifact.fullscreen': '全屏',

  'job.status': '状态',
  'job.pending': '排队中',
  'job.processing': '处理中…',
  'job.done': '完成',
  'job.failed': '失败',
  'job.cancelled': '已取消',
  'job.result': '结果',
  'job.empty': '还没有生成',
  'job.actions': '操作',
  'job.favoriteAdd': '添加到收藏',
  'job.favoriteRemove': '从收藏中移除',
  'job.favorited': '收藏',
  'job.regenerate': '重新生成',
  'job.viewPrompt': '查看提示词',
  'job.promptTitle': '提示词',
  'job.download': '下载',
  'job.deleteTitle': '删除此生成？',
  'job.deleteConfirm': '此生成将被永久删除。',

  'design.subtitle': '在新窗口中打开设计工具',
  'design.open': '打开',

  'settings.title': '设置',
  'settings.profile': '个人资料',
  'settings.appearance': '外观',
  'settings.theme': '主题',
  'settings.themeLight': '浅色',
  'settings.themeDark': '深色',
  'settings.themeSystem': '跟随系统',
  'settings.language': '语言',
  'settings.balance': '余额',
  'settings.topup': '充值',
  'settings.topupAmount': '金额, ₽',
  'settings.topupSubmit': '充值余额',
  'settings.transactions': '交易记录',
  'settings.noTransactions': '还没有交易',
  'settings.loadMore': '加载更多',
  'settings.notifications': '通知',
  'settings.notificationsHint': '生成完成时通知我',
  'settings.data': '你的数据',
  'settings.exportData': '导出我的数据',
  'settings.deleteAccount': '删除账户',
  'settings.deleteAccountTitle': '删除你的账户？',
  'settings.deleteAccountConfirm': '这将永久删除你的账户、对话和余额，且无法撤销。',
  'settings.username': '用户名',
  'settings.name': '姓名',

  'admin.title': '管理',
  'admin.stats': '统计',
  'admin.users': '用户',
  'admin.settings': '平台设置',
  'admin.markup': '加价, %',
  'admin.usdRub': 'USD → RUB 汇率',
  'admin.minBalance': '最低余额, ₽',
  'admin.contextLimit': '上下文消息数',
  'admin.models': '模型价格',
  'admin.price': '价格',
  'admin.revenue': '收入',
  'admin.cost': '供应商成本',
  'admin.margin': '利润',
  'admin.activeUsers': '活跃 (24 小时)',
  'admin.failedJobs': '失败任务',
  'admin.ban': '封禁',
  'admin.unban': '解封',
  'admin.adjustBalance': '调整余额',
  'admin.reason': '原因',
  'admin.amount': '金额, ₽',
  'admin.errorHistory': '错误历史',
  'admin.errorsEmpty': '尚未记录任何错误。',

  'error.UNAUTHORIZED': '会话已过期，请重新打开应用。',
  'error.FORBIDDEN': '你没有访问权限。',
  'error.USER_BANNED': '你的账户已被封禁。',
  'error.NOT_FOUND': '未找到。',
  'error.RATE_LIMITED': '请求过多，请放慢速度。',
  'error.DAILY_LIMIT_EXCEEDED': '已达每日上限，请明天再试。',
  'error.INSUFFICIENT_BALANCE': '余额不足以完成此请求。',
  'error.BELOW_MIN_BALANCE': '你的余额低于最低要求。',
  'error.MODEL_UNAVAILABLE': '该模型当前不可用。',
  'error.MODEL_NOT_SUPPORTED': '此处不支持该模型。',
  'error.PROVIDER_ERROR': '供应商返回了错误。',
  'error.PROVIDER_TIMEOUT': '供应商超时。',
  'error.CONTEXT_TOO_LARGE': '此对话对模型来说太长了。',
  'error.PAYMENT_INVALID': '无法处理付款。',
  'error.INTERNAL': '服务器错误，请重试。',
  'error.network': '网络错误，请检查连接。',
  'error.streamInterrupted': '连接中断，已从服务器恢复回复。',
  'error.generic': '出错了。',
};
